import { formatDate } from '../utils';
import { DISPLAY_MODES, SHIFT_TYPES } from '../constants';

export default function filterOutputByModeAndDate(displayMode, day) {
  if (displayMode === DISPLAY_MODES.DAY) {
    return () => true;
  }

  return function _filterOutputByModeAndDate(event) {
    return day === formatDate(event.dtstart) || !SHIFT_TYPES.includes(event.type);
  };
}
